import { IonContent, IonPage } from '@ionic/react';
import { useEffect } from 'react';

const AuthCallback: React.FC = () => {
    useEffect(() => {
      if (window.opener) {
        // Let the popup return control to the main window
        window.opener.postMessage(
          { type: 'oauth2:callback', url: window.location.href },
          window.origin
        );
        window.close();
      }
    }, []);
  
    return (
      <IonPage>
        <IonContent className="ion-padding">
          <p>Finalizing login...</p>
        </IonContent>
      </IonPage>
    );
  };
  
  export default AuthCallback;